module.exports = __webpack_public_path__ + "static/media/hollow_bar_preinspect.2d09b9be.svg";